export default __webpack_public_path__ + "static/media/4.9e3d51a8.svg";